export const hexToRGB = (hex: string, alpha?: string): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};

export const getCenterFromCoordinates = (
  coordinatesList: { lat: number; lng: number }[]
): { lat: number; lng: number } => {
  if (coordinatesList.length === 0) {
    return { lat: 0, lng: 0 };
  }
  const latValues = coordinatesList.map((coordinate) => coordinate.lat);
  const lngValues = coordinatesList.map((coordinate) => coordinate.lng);

  const minLat = Math.min(...latValues);
  const maxLat = Math.max(...latValues);
  const minLng = Math.min(...lngValues);
  const maxLng = Math.max(...lngValues);

  const centerLat = minLat + (maxLat - minLat) * 0.5;
  const centerLng = minLng + (maxLng - minLng) * 0.5;

  return { lat: centerLat, lng: centerLng };
};
